import Datatable from "./datatable_controller";

// Connects to data-controller="internal-event-subcategory-datatable"
export default class extends Datatable {
  get columns() {
    return [
      { data: "name" },
      { data: "image" },
      { data: "actions" }
    ];
  }

  get searching() {
    return true;
  }

  get ordering() {
    return true;
  }

  get order() {
    return [[0, "asc"]];
  }

  get lengthChange() {
    return false;
  }
}
